import "../assets/scss/styles.scss";
import "../node_modules/bootstrap/js/dist/collapse";

import "./modules/accordions.js";
import "./modules/counters.js";
import "./modules/lightbox.js";
import "./modules/menu.js";
import "./modules/form.js";
import "./modules/header.js";
import "./modules/projects.js";
import "./modules/scrollup.js";
import "./modules/sliders.js";
